import React, {useState} from 'react';
import classes from './styles.module.css'
import Container from '../../Container';
import { ReactComponent as GuideFormImage } from '../../../images/guideForm/guide_form_image.svg';
import useForm from '../../../hooks/useForm';
import { validate } from '../formValidationRules';
import { useMutation } from '@apollo/client';
import { subscribeMutationGql } from '../../../graphql/mutations.gql';
import ModalSuccess from '../../Modals/ModalSuccess';
import ModalError from '../../Modals/ModalError';
import useHash from '../../../hooks/useHash';

const GuideForm = ({ id }) => {
    const [guideFormFunction] = useMutation(subscribeMutationGql);
    const [isOpenSuccessModal, setIsOpenSuccessModal] = useState(false);
    const [isOpenErrorModal, setIsOpenErrorModal] = useState(false);
    const [errorText, setErrorText] = useState('');

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        handleReset,
    } = useForm(handleGuideForm, validate);

    function handleGuideForm() {
        guideFormFunction({
            variables: {
                type: 'Guide',
                fullName: values.name,
                email: values.email,
            }
        }).then(response => {
            if (response?.data?.subscribe?.id) {
                setIsOpenSuccessModal(true)
                handleReset()
            }
            if (response?.errors?.[0]?.message) {
                setErrorText(response?.errors?.[0]?.message)
                setIsOpenErrorModal(true)
            }
        }).catch((error) => {
            if (error?.message) {
                setErrorText(error?.message)
                setIsOpenErrorModal(true)
            }
        })
    }

    useHash();

    return (
        <>
            <div id={id} className={classes.guideForm}>
                <Container>
                    <div className={classes.guideFormContainer}>
                        <GuideFormImage className={classes.guideFormImage} />
                        <div className={classes.guideFormInfoAdaptive}>
                            Special conditions for the first 100 Guides!
                        </div>
                        <form className={classes.guideFormWrapper} onSubmit={handleSubmit} noValidate>
                            <div className={classes.preTitle}>Hey Guide!</div>
                            <div className={classes.guideFormTitle}>Don’t miss your chance!</div>
                            <div className={classes.subTitle}>Become part of Umeguide!</div>
                            <div className={classes.subTitleAdaptive}>
                                You will receive not only a 10% discount for any tour but also news about our fresh and fantastical tours
                            </div>
                            <div className={classes.guideFormRow}>
                                <div className={classes.inputWrapper}>
                                    <input
                                        autoComplete='off'
                                        className={errors.name && errors.name ? `${classes.inputField} ${classes.error}` : `${classes.inputField}`}
                                        type='text'
                                        name='name'
                                        onChange={handleChange}
                                        value={values.name || ''}
                                        placeholder='Full Name'
                                        required
                                    />
                                    <p className={classes.inputError}>
                                        {errors.name && errors.name}
                                    </p>
                                </div>
                                <div className={classes.inputWrapper}>
                                    <input
                                        autoComplete='off'
                                        className={errors.email && errors.email ? `${classes.inputField} ${classes.error}` : `${classes.inputField}`}
                                        type='email'
                                        name='email'
                                        onChange={handleChange}
                                        value={values.email || ''}
                                        placeholder='Email'
                                        required
                                    />
                                    <p className={classes.inputError}>
                                        {errors.email && errors.email}
                                    </p>
                                </div>
                            </div>
                            <div className={classes.guideFormRow}>
                                <button type='submit' className={classes.guideFormButton}>Submit</button>
                                <div className={classes.guideFormInfo}>
                                    Special conditions for the first 100 Guides!
                                </div>
                            </div>
                        </form>
                    </div>
                </Container>
            </div>

            <ModalSuccess isOpenSuccessModal={isOpenSuccessModal} setIsOpenSuccessModal={setIsOpenSuccessModal} />
            <ModalError errorText={errorText} isOpenErrorModal={isOpenErrorModal} setIsOpenErrorModal={setIsOpenErrorModal} />
        </>
    );
};

export default GuideForm;